import LoginPage from "@auth/ui/pages/LoginPage";
import CompanyPage from "@companies/ui/pages/CompanyPage";
import CompanyProcessPage from "@companyProcess/ui/pages/CompanyProcessPage";
import { AuthenticationLayout } from "@shared/layouts/AuthenticationLayout";
import { AuthorizationLayout } from "@shared/layouts/AuthorizationLayout";
import MainOutlet from "@shared/outlets/MainOutlet";
import Dashboard from "@shared/pages/Dashboard";
import NotFoundPage from "@shared/pages/NotFoundPage";
import Unauthorized from "@shared/pages/Unauthorized";
import { RouteObject } from "react-router-dom";

export const routes: Array<RouteObject> = [
    { path: '/login', Component: LoginPage },
    {
        path: '/',
        Component: AuthenticationLayout,
        children: [
            {
                Component: MainOutlet,
                children: [
                    { path: '/dashboard', Component: Dashboard },
                    { path: '/unauthorized', Component: Unauthorized },
                    { 
                        path: '/', 
                        Component: AuthorizationLayout,
                        children: [
                            { path: '/empresas', Component: CompanyPage },
                            { path: '/empresas-proceso', Component: CompanyProcessPage }
                        ] 
                    },
                    
                ],
            },
        ],
    },
    { path: '/*', Component: NotFoundPage }
]